module.exports = __webpack_public_path__ + "media/images/box_sizes/L-6a1acdc3553b1864711eb0c8bc26352e.jpg";